import { useCore } from '$api-clients/hooks';

// Focus revalidation is off: writes merge their response into the cache, and the
// form seeds from this data once.
export function useContactsData(interactionId: string, skip = false) {
  return useCore(
    '/interactions/{interactionId}/contacts',
    skip ? null : { params: { path: { interactionId } } },
    { revalidateOnFocus: false },
  );
}
